var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }